import React from "react";
import ScreenContent from "../../../components/layout/ScreenContent";

const ScreenBodyWrapper = ({ children }) => {
  return (
    <ScreenContent
      sx={{
        p: 0,
        height: "100%",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        position: "relative",
      }}
    >
      {children}
    </ScreenContent>
  );
};

export default ScreenBodyWrapper;
